import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "../lib/api";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sid) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const d = await api.paymentStatus(sid);
        if (d.payment_status === "paid") { setStatus("paid"); return; }
        if (d.status === "expired" || d.payment_status === "failed") { setStatus("error"); return; }
      } catch { /* retry */ }
      if (tries++ < 8) setTimeout(poll, 2000); else setStatus("pending");
    };
    poll();
  }, [sid]);

  return (
    <div className="flex flex-col items-center px-4 py-24 text-center" data-testid="payment-success-page">
      {status === "checking" && <><Loader2 className="h-12 w-12 animate-spin text-brand" /><p className="mt-4 font-semibold">Confirmando tu pago...</p></>}
      {status === "paid" && <><CheckCircle2 className="h-14 w-14 text-emerald-600" /><h1 className="mt-4 font-display text-2xl font-extrabold">¡Pago confirmado!</h1><p className="mt-2 text-muted-foreground">Tu negocio ya está destacado. ¡Gracias!</p></>}
      {status === "pending" && <><Loader2 className="h-12 w-12 text-amber-500" /><h1 className="mt-4 font-display text-2xl font-bold">Pago en proceso</h1><p className="mt-2 text-muted-foreground">Lo confirmaremos en breve.</p></>}
      {status === "error" && <><XCircle className="h-14 w-14 text-rose-500" /><h1 className="mt-4 font-display text-2xl font-bold">No se pudo confirmar</h1></>}
      <Link to="/" className="mt-6 rounded-full bg-brand px-6 py-3 text-sm font-bold text-white hover:bg-brand-hover">Volver al inicio</Link>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="flex flex-col items-center px-4 py-24 text-center" data-testid="payment-cancel-page">
      <XCircle className="h-14 w-14 text-muted-foreground" />
      <h1 className="mt-4 font-display text-2xl font-bold">Pago cancelado</h1>
      <p className="mt-2 text-muted-foreground">No se realizó ningún cargo.</p>
      <Link to="/" className="mt-6 rounded-full bg-brand px-6 py-3 text-sm font-bold text-white hover:bg-brand-hover">Volver al inicio</Link>
    </div>
  );
}
